import {
  AmountField,
  Button,
  CardContent,
  InputField,
  Modal,
  NumberField,
  PhoneField,
  SelectField,
  SubmitButton,
} from '@shazambanking/sdk/components';
import DatePickerField from '@shazambanking/sdk/components/form/DatePickerField';
import { useFormikContext } from 'formik';
import moment from 'moment';
import * as React from 'react';
import { Col, Row } from 'reactstrap';
import getInitialNewAccountValues from '../getInitialNewAccountValues';
import { AccountProduct, NewAccountFormValues, NewAccountStartupResource } from '../types';
import { l10n as naoL10n } from '../l10n/newAccount';
import { mapL10nKeys } from '../../common/util/l10n';
// import { fetchNewAccountStartupData } from '../api/newAccount';
import { 
  // useEffect,
   useState } from 'react';
// import setL10N from 'src/core/store/sagas/util/setL10n';
// import { showErrorNotification } from '@shazambanking/sdk/services/notifications';
// import { get } from 'lodash';

interface Props {
  defaultValues?: Partial<NewAccountFormValues>;
  startupData: NewAccountStartupResource;
}

export default function NewAccountFormFields({ defaultValues, startupData }: Props) {
  const { resetForm, values } = useFormikContext<NewAccountFormValues>();
  const [showModal, setShowModal] = useState<boolean>(false);
  // njansen 5/13/22 - jankety solution to make l10n work without app bootstrap, this needs called on every page requiring l10n
  const l10n = mapL10nKeys(naoL10n);

  const clearForm = () => {
    setShowModal(false);
    resetForm({ values: getInitialNewAccountValues(defaultValues) });
  };

  const getStateAbbreviations = () => {
    let stateAbbreviations: String[] = [];
    startupData?.states.map((state) => stateAbbreviations.push(state.abbreviation));
    return stateAbbreviations.sort();
  }

  const getDepositSources = () => {
    return [l10n.depositSource.cash, l10n.depositSource.check, l10n.depositSource.internalTransfer, l10n.depositSource.externalTransfer];
  }

  return (
    <div className="challenge-controls">
      <CardContent>
        <Row>
          <Col md={12}>
            <SelectField<AccountProduct>
              name="accountProduct"
              label={l10n.accountProductLabel}
              required
              placeholder={l10n.accountProductPlaceholder}
              options={startupData.accountProducts}
              optionLabel={(accountProduct: AccountProduct) => accountProduct.name}
              fieldValue={'sourceProductId'}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4}>
            <InputField
              name="firstName"
              label={l10n.firstNameLabel}
              required
              maxLength={18}
            />
          </Col>
          <Col md={3}>
            <InputField
              name="middleName"
              label={l10n.middleNameLabel}
              maxLength={18}
            />
          </Col>
          <Col md={5}>
            <InputField
              name="lastName"
              label={l10n.lastNameLabel}
              required
              maxLength={40}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputField
              name="address1"
              label={l10n.address1Label}
              required
              maxLength={40}
            />
          </Col>
          <Col md={6}>
            <InputField
              name="address2"
              label={l10n.address2Label}
              maxLength={40}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputField
              name="city"
              label={l10n.cityLabel}
              required
              maxLength={24}
            />
          </Col>
          <Col md={3}>
            <SelectField
              name="state"
              label={l10n.stateLabel}
              required
              placeholder={l10n.statePlaceholder}
              options={getStateAbbreviations()}
            />
          </Col>
          <Col md={3}>
            <NumberField
              name="zip"
              label={l10n.zipLabel}
              required
              maxLength={5}
              allowLeadingZeroes
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <NumberField
              name="ssnLastFour"
              label={l10n.ssnLastFourLabel}
              required={!values.dateOfBirth}
              maxLength={4}
              allowLeadingZeroes
            />
          </Col>
          <Col md={6}>
            <DatePickerField
              name="dateOfBirth"
              label={l10n.dateOfBirthLabel}
              startDate={moment().subtract({ years: 100 })}
              endDate={moment()}
              firstDayOfWeek={0}
              color={"default"}
              required={!values.ssnLastFour || (values.ssnLastFour.length === 0)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <InputField
              name="email"
              label={l10n.emailLabel}
              required
              maxLength={128}
            />
          </Col>
          <Col md={6}>
            <PhoneField
              name="primaryPhone"
              label={l10n.primaryPhoneLabel}
              required
            />
          </Col>
        </Row>
        <Row>
          <Col md={6}>
            <SelectField
              name="depositSource"
              label={l10n.depositSourceLabel}
              required
              placeholder={l10n.depositSourcePlaceholder}
              options={getDepositSources()}
            />
          </Col>
          <Col md={6}>
            <AmountField
              label={l10n.amountLabel}
              name="amount"
              required
            />
          </Col>
        </Row>
      </CardContent>
      <Modal
        isOpen={showModal}
        isCentered
        title={l10n.clearModal.title}
        text={l10n.clearModal.text}
        onConfirm={clearForm}
        onClose={() => setShowModal(false)}
        confirmText={l10n.confirmBtn}
        cancelText={l10n.cancelBtn}
      />
      <CardContent>
        <div className="actions d-flex justify-content-end">
          <Button outlined className="clear-btn mr-4" onClick={() => setShowModal(true)}>
            {l10n.clearBtn}
          </Button>
          <SubmitButton className="submit-btn">{l10n.submitBtn}</SubmitButton>
        </div>
      </CardContent>
    </div>);
};
